import { render } from "./ReviewComponent.vue?vue&type=template&id=5a44e878"
import script from "./ReviewComponent.vue?vue&type=script&lang=js"
export * from "./ReviewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__